import React, { Component } from 'react';
import SLinkCardOnboarding from 'shared/screens/RewardCenter/LinkCardOnboarding';
import theme from 'shared/assets/style/theme';
import ImageBW from '../../components/ImageBoundsWrapper';
import CopySelector from 'shared/utils/copySelector';

export default class LinkCardOnboarding extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-link-card-onboarding',
    };
  }

  render() {
    return (
      <SLinkCardOnboarding
        navigation={this.props.navigation}
        render={args => {
          const { showUpgradeFlow, dismissLinkAccountPopUp, linkedLoyaltyCardBonus } = args;
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '94%',
              }}
            >
              <div className="ModalCloseButton" onClick={dismissLinkAccountPopUp}>
                <ImageBW
                  source={require(asset`CloseButton@3x.png`)}
                  ibw={require(asset`CloseButton.ibw`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  resizeMode="contain"
                />
              </div>
              <span
                style={{
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '1em',
                  fontWeight: 600,
                  fontSize: 'calc(18px + (26 - 18) * ((100vw - 800px) / (1600 - 800)))',
                  textShadow: `2px 2px 4px ${theme.palette.common[0]}`,
                  textTransform: 'uppercase',
                }}
                className="rewardCenterGradientText"
                data-label={'member of the star club?'}
              >
                {CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_ACCOUNT_ONBOARDING_TITLE)}
              </span>
              <ImageBW
                source={require(asset`Shop_VIP_Divider_Glows@3x.png`)}
                ibw={require(asset`Shop_VIP_Divider_Glows.ibw`)}
                manualAssetScale={3}
                style={{ height: '7vmin', width: '100%', marginTop: '1vmin' }}
                innerStyle={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                  paddingLeft: '1vmin',
                  paddingRight: '1vmin',
                }}
              ></ImageBW>
              <span
                style={{
                  position: 'relative',
                  width: '40%',
                  height: '45%',
                  bottom: '1em',
                }}
              >
                <img
                  alt=""
                  src={require(asset`images/Rewards_Center_Assets/TSC_Cards@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </span>
              <div className="RewardCenterLinkAccountMessage">
                {`${CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_ACCOUNT_ONBOARDING_SUBTITLE)} ${
                  linkedLoyaltyCardBonus.amount
                } ${linkedLoyaltyCardBonus.currency}`}
              </div>
              <div className="RewardCenterLinkAccountAction" onClick={showUpgradeFlow}>
                <img
                  alt=""
                  src={require(asset`images/Rewards_Center_Assets/Link_Button@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </div>
          );
        }}
      />
    );
  }
}

LinkCardOnboarding.hideCloseButton = true;
